import React, { useState } from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  useTheme, 
  useMediaQuery, 
  Box,
  Collapse,
  IconButton,
  Typography
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

function CuentasTableEasy({ data }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const fieldNames = data.length > 0 ? Object.keys(data[0]) : [];
  const excludedFields = ['id', 'llave'];
  const [open, setOpen] = useState({});

  const handleOpen = (index) => {
    setOpen(prevState => ({ ...prevState, [index]: !prevState[index] }));
  }

  const filteredFieldNames = fieldNames.filter(fieldName => !excludedFields.includes(fieldName));
  const visibleFields = isSmallScreen ? filteredFieldNames.slice(0, 3) : filteredFieldNames.slice(0, 11); 

  const tableStyle = { fontSize: '0.8rem' };
  const cellStyle = { padding: '6px 3px' };

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const beautifyHeader = (header) => {
    return header.split('_').map(capitalize).join(' ');
  };

  return (
    <Paper sx={{ mb: 2, backgroundColor: theme.palette.componentBackground.default }}>
        <Typography variant="h5" align="center" gutterBottom>DETALLE DE CUENTA</Typography>
    <TableContainer component={Paper} style={{backgroundColor: theme.palette.componentBackground.default}}>
      <Box sx={{ overflowX: 'auto' }}>
        <Table style={tableStyle}>
          <TableHead>
            <TableRow>
              <TableCell />
              {visibleFields.map((fieldName, index) => (
                <TableCell key={index} style={cellStyle}>{beautifyHeader(fieldName)}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <TableRow >
                  <TableCell style={cellStyle}>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => handleOpen(rowIndex)}
                    >
                      {open[rowIndex] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  </TableCell>
                  {visibleFields.map((fieldName, cellIndex) => (
                    <TableCell key={cellIndex} style={cellStyle}>{row[fieldName]}</TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={visibleFields.length + 1}>
                    <Collapse in={open[rowIndex]} timeout="auto" unmountOnExit>
                      <Box sx={{ margin: 1 }}>
                        <Typography variant="h6" gutterBottom component="div">
                          Detalles
                        </Typography>
                        {filteredFieldNames.map((fieldName, index) => (
                          <Typography key={index} variant="body2">
                            <strong>{beautifyHeader(fieldName)}:</strong> {row[fieldName]}
                          </Typography>
                        ))}
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
                </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
    </Paper>

  );
}

export default CuentasTableEasy;
